/**
 * Ngữ cảnh mẫu của `GET /api/v1/users/me/context`, dùng khi đã đăng nhập
 * Keycloak thật nhưng đang soát giao diện bằng `?mock=`.
 *
 * Tenant thuê **toàn diện** và người dùng có quyền ở mọi module, nên `?mock=`
 * vẫn mở được mọi màn để soát bốn trạng thái. Role lớp 1 lấy đúng từ token:
 * `TENANT_USER` vẫn không thấy Cấu hình hệ thống, như khi chạy thật.
 *
 * ⚠️ Tầng này bị xoá khi API thật về.
 */
import type { MyContext } from '../modules/auth/nghiep-vu/types';
import { MOCK_DICH_VU } from './goi-dich-vu';
import { QUYEN_BAO_CAO_MAU, QUYEN_BIEN_BAN_MAU, QUYEN_TRI_THUC_MAU } from './fixtures';

export function nguCanhMau(vaiTroLop1: readonly string[]): MyContext {
  return {
    tenant_id: 'mock-tenant',
    user_id: 'mock-user',
    active: true,
    // Màn tri thức, báo cáo đọc mã quyền module nguyên văn (ADR-0075, ADR-0081): đủ quyền để soát mọi nút.
    permissions: [...QUYEN_TRI_THUC_MAU, ...QUYEN_BAO_CAO_MAU, ...QUYEN_BIEN_BAN_MAU],
    mods: [...new Set(MOCK_DICH_VU.flatMap((d) => d.vung_api))],
    roles: { platform: [...vaiTroLop1], tenant: [] },
    dich_vu: MOCK_DICH_VU.map((d) => d.ma),
    // Dữ liệu mẫu luôn là tổ chức đang hoạt động: không hiện băng tạm ngưng.
    tenant_status: 'ACTIVE',
  };
}
